// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const FooterBBB: React.FC<{ width?: number; height?: number }> = ({ width = 15, height = 24 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.95 22.965c.533 0 .855-.186.855-.574v-.017c0-.363-.275-.575-.892-.575h-1.392v1.195zm-.318-2.186c.53 0 .869-.173.869-.575 0-.36-.29-.575-.788-.575h-1.192v1.15zm-2.284-2.196h2.542a1.98 1.98 0 0 1 1.43.48c.247.243.382.577.373.923v.017c.014.496-.267.954-.718 1.17.634.24 1.025.606 1.025 1.336 0 .994-.813 1.491-2.05 1.491h-2.605zm-2.556 4.382c.533 0 .851-.186.851-.574v-.017c0-.363-.272-.575-.888-.575H6.348v1.195zm-.318-2.186c.53 0 .868-.173.868-.575 0-.36-.29-.575-.787-.575H6.348v1.15zM5.19 18.583h2.542a1.98 1.98 0 0 1 1.43.48c.246.244.38.578.37.923v.017c.014.496-.267.954-.718 1.17.634.24 1.025.606 1.025 1.336 0 .994-.814 1.491-2.05 1.491H5.19zm-2.576 4.383c.532 0 .85-.187.85-.575v-.017c0-.363-.271-.575-.888-.575h-1.4v1.195zm-.319-2.187c.53 0 .869-.173.869-.575 0-.36-.29-.575-.79-.575H1.175v1.15zM.003 18.583h2.541a1.98 1.98 0 0 1 1.43.48c.248.243.383.577.374.923v.017c.014.496-.267.954-.718 1.17.63.24 1.022.606 1.022 1.336 0 .994-.81 1.491-2.047 1.491H0zM5.7 2.437a3.12 3.12 0 0 0-.565 2.347c.13.827.587 1.568 1.27 2.058l2.791 2.011a1.676 1.676 0 0 1 .377 2.354l.269.192 2.197-3.014a3.146 3.146 0 0 0-.71-4.405L7.964 1.552a.96.96 0 0 1-.39-.635.95.95 0 0 1 .173-.724L7.48 0zm-1.338 6.43a2.165 2.165 0 0 0 .486 3.038l2.22 1.6a.54.54 0 0 1 .122.762l.333.239 1.172-1.604a2.15 2.15 0 0 0 .391-1.62 2.17 2.17 0 0 0-.868-1.42L6 8.264a.53.53 0 0 1-.232-.356.4.4 0 0 1 0-.086c0-.115.037-.226.104-.32l-.333-.24zm7.758 6.179H2.848l-.336 1.1h2.473l.468 1.518h4.062l.471-1.517h2.47z"
            />
        </svg>
    );
};

export default React.memo(FooterBBB);
